import { forEach } from "lodash";
import PGSHelper from "../../helpers/PGSHelper.js";
let pgsHelper = new PGSHelper();
import _ from "lodash";
export default class ValoracionInventarios {
  constructor() {}

  static getDocData(mainData) {
    console.log("mainData", mainData);
    let getTable = this.getTable(mainData.data);

    let imgColumn = {
      text: "",
      width: "10%",
    };
    let docDefinition = {
      pageMargins: [20, 20, 20, 20],
      pageOrientation: "portrait",
      content: [
        //header
        {
          columns: [
            {
              // fixed width
              width: "100%",
              alignment: "center",
              bold: true,
              text: [mainData.TITLE + "\n"],
            },
          ],
        },
        {
          columns: [
            {
              // fixed width
              width: "35%",
              alignment: "left",
              bold: true,
              text: ["Almacen: " + mainData.Almacen + "\n",  "Departamento: " + mainData.Departamento + "\n"],
            },
            {
              // fixed width
              width: "35%",
              alignment: "left",
              bold: true,
              text: [],
            },
            {
              // % width
              width: "30%",
              bold: true,
              text: [
                "Generado: " + mainData.FG + "\n",
                "Hora Generado: " + mainData.HG + "\n",
              ],
            },
          ],
          columnGap: 10,
        },
        {
          columns: [
            {
              width: "100%",
              table: {
                widths: [ '20%', '30%', '10%',  '10%', '10%', '10%', '10%' ],
                heights: 25,
                body: getTable,
              },
            },
          ],
          margin: [0, 0, 0, 0],
        },
      ],
    };
    return docDefinition;
  }

  static getTable(data, totales) {
    let headers = [
      {
        text: "Nombre",
        border: [true, true, true, true],
        fontSize: 10,
        alignment: "center",
      },
      {
        text: "Categoria",
        border: [true, true, true, true],
        fontSize: 10,
        alignment: "center",
      },
      {
        text: "Existencia",
        border: [true, true, true, true],
        fontSize: 10,
        alignment: "center",
      },
      {
        text: "Costo Promedio",
        border: [true, true, true, true],
        fontSize: 10,
        alignment: "center",
      },
      {
        text: "Ultimo costo",
        border: [true, true, true, true],
        fontSize: 10,
        alignment: "center",
      },
      {
        text: "Total Promedio",
        border: [true, true, true, true],
        fontSize: 10,
        alignment: "center",
      },
      {
        text: "Total Ultimo Costo",
        border: [true, true, true, true],
        fontSize: 10,
        alignment: "center",
      },
    ];

    let items = [headers];

    data.forEach((item) => {
      let rowToAdd = [];

      rowToAdd = [
        {
          text: [item.Nombre],
          fontSize: 10,
          alignment: "center",
        },
        {
          text: [item.NombreCategoria],
          fontSize: 10,
          alignment: "center",
        },
        {
          text: pgsHelper.formatNumber(item.Existencia) + " " + item.UnidadMedida,
          fontSize: 10,
          alignment: "center",
          fillColor: (Number(item.Existencia) == 0) ? "#FF9F8B" : "",
        },
        {
          text: "$" + pgsHelper.formatNumber(item.Costo),
          fontSize: 10,
          alignment: "center",
        },
        {
          text: "$" + pgsHelper.formatNumber(item.UltimoCosto),
          fontSize: 10,
          alignment: "center",
        },
        {
          text: "$" + pgsHelper.formatNumber(item.Total),
          fontSize: 10,
          alignment: "center",
        },
        {
          text: "$" + pgsHelper.formatNumber(item.TotalUltimoCosto),
          fontSize: 10,
          alignment: "center",
        },
      ];
      items.push(rowToAdd);
    });

    return items;
  }
}
